/* Well Hello Gorgeous — Guild signup.
   Records where each subscriber came from, then sends them to Klaviyo.
   First touch wins: the source that first brought someone to the site is the
   one credited, even if they sign up on a later visit. */
(function () {
  var KEY = 'whg_first_touch';

  function firstTouch() {
    try {
      var saved = JSON.parse(localStorage.getItem(KEY) || 'null');
      if (saved) return saved;
    } catch (e) {}
    var q = new URLSearchParams(location.search);
    var t = {
      utm_source: q.get('utm_source') || (document.referrer ? 'referral' : 'direct'),
      utm_medium: q.get('utm_medium') || '',
      utm_campaign: q.get('utm_campaign') || '',
      utm_content: q.get('utm_content') || '',
      utm_term: q.get('utm_term') || '',
      landing_page: location.pathname,
      referrer: document.referrer || ''
    };
    try { localStorage.setItem(KEY, JSON.stringify(t)); } catch (e) {}
    return t;
  }

  function init(form) {
    var touch = firstTouch();
    form.querySelectorAll('[data-utm]').forEach(function (input) {
      input.value = touch[input.getAttribute('data-utm')] || '';
    });

    var list = form.getAttribute('data-klaviyo-list');
    var company = form.getAttribute('data-klaviyo-company');
    if (!list || !company) return; // Shopify's own form handles it

    var msg = form.parentNode.querySelector('.whg-signup__msg');
    var btn = form.querySelector('.whg-signup__btn');

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = form.querySelector('input[type=email]').value.trim();
      if (!email || email.indexOf('@') < 1) {
        msg.textContent = 'Please enter a valid email address.';
        msg.setAttribute('data-state', 'error');
        return;
      }
      var original = btn.textContent;
      btn.disabled = true; btn.textContent = 'One moment';
      msg.removeAttribute('data-state'); msg.textContent = '';

      var props = {};
      form.querySelectorAll('[data-utm]').forEach(function (i) {
        if (i.value) props[i.name] = i.value;
      });

      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(company), {
        method: 'POST',
        headers: { 'content-type': 'application/json', revision: '2024-10-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              profile: { data: { type: 'profile', attributes: { email: email, properties: props } } }
            },
            relationships: { list: { data: { type: 'list', id: list } } }
          }
        })
      }).then(function (r) {
        if (r.ok || r.status === 202) {
          form.style.display = 'none';
          msg.textContent = "You're in. Watch your inbox.";
        } else {
          throw new Error('status ' + r.status);
        }
      }).catch(function () {
        msg.textContent = 'That did not go through. Please try again.';
        msg.setAttribute('data-state', 'error');
        btn.disabled = false; btn.textContent = original;
      });
    });
  }

  document.querySelectorAll('.whg-signup__form').forEach(init);
})();
